import { parseUrlSearchParams } from '../config';

export function filterFramesByLocation(frames, locationHref) {
  const result = [];
  for (let index = 0; index < frames.length; index++) {
    const frame = frames[index];
    try {
      if (frame.location.origin === locationHref) {
        result.push(frame);
      }
    } catch (e) {} // eslint-disable-line no-empty
  }

  return result;
}

export function filterFramesByFieldId(fieldId = '', frames = []) {
  frames = frames || filterFramesByLocation(window.parent.frames, window.location.origin);

  return frames.filter((frame) => {
    const configuration = parseUrlSearchParams(frame.location.hash);
    return configuration.fieldId === fieldId;
  });
}

export function filterFramesByFieldType(type = '', frames = []) {
  frames = filterFramesByLocation(window.parent.frames, window.location.origin);
  return frames.filter((frame) => {
    const configuration = parseUrlSearchParams(frame.location.hash);
    return configuration.type === type;
  });
}
